import { render, staticRenderFns } from "./_sns_dashbord.vue?vue&type=template&id=88f1e33a&"
import script from "./_sns_dashbord.vue?vue&type=script&lang=js&"
export * from "./_sns_dashbord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports